export default {
  UNDER_ANALYSIS: 1,
  ACCEPTED: 2,
  DECLINED: 3,
};
